.content {
	background-color: var(--depth3);
	color: var(--textPrimary);
	font-size: 1rem;
	word-wrap: break-word;
	border-radius: var(--roundedBig);
	min-width: max-content;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 0.5rem;
	letter-spacing: 0.1rem;
}
.content h1 {
	color: var(--textPrimary);
}

.text {
	margin-top: 1rem;
	text-align: center;
}
.svg {
	fill: var(--primary);
}
.svg:last-child {
	fill: var(--yellow);
}
